import { Heading } from '@big-red-group/storefront-common-ui'
import CategoryPill from './CategoryPill'
import { useState } from 'react'
import { CategoriesWrapper, Categories, ShowMore } from './PopularCategories.styles'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import { ProductListCarousel, SwiperHeadingContainer, SwiperButtons, SwiperLeft, SwiperRight } from './Swiper.styles'
import { Navigation } from 'swiper/modules'
import { Spacing } from '@big-red-group/storefront-common-ui'
import { LIST_SIZE } from '@/constant/segment'

export type PopularCategoriesProps = {
  region: string
  categories: { name: string; link: string; image: string }[]
}

const PopularCategories: React.FC<PopularCategoriesProps> = ({ categories, region }) => {
  const [lastIndex, setLastIndex] = useState(LIST_SIZE)
  const [showMore, setShowMore] = useState(false)

  const handlePrev = () => {
    if (lastIndex === LIST_SIZE) return
    setLastIndex(lastIndex - 1)
  }

  const handleNext = () => {
    if (lastIndex === categories.length) return
    setLastIndex(lastIndex + 1)
  }

  const widgetPrev = '-prev'
  const widgetNext = '-next'

  return (
    <>
      <SwiperHeadingContainer>
        <Heading as="h2" size="XL">
          Popular categories
        </Heading>
        <SwiperButtons>
          <SwiperLeft data-testid={widgetPrev} className={widgetPrev} onClick={handlePrev}></SwiperLeft>
          <SwiperRight data-testid={widgetNext} className={widgetNext} onClick={handleNext}></SwiperRight>
        </SwiperButtons>
      </SwiperHeadingContainer>
      <Spacing />
      <CategoriesWrapper showMore={showMore}>
        <ProductListCarousel>
          <Swiper
            modules={[Navigation]}
            navigation={{ prevEl: `.${widgetPrev}`, nextEl: `.${widgetNext}` }}
            breakpoints={{
              0: {
                slidesPerView: 'auto',
                enabled: false,
              },
              768: {
                spaceBetween: 16,
                slidesPerView: 3,
              },
              1200: {
                spaceBetween: 24,
                slidesPerView: 4,
              },
              1450: {
                spaceBetween: 20,
                slidesPerView: 5,
              },
            }}
          >
            <Categories>
              {categories.map(({ name, image, link }) => (
                <SwiperSlide key={link}>
                  <CategoryPill image={image} name={name} url={`/en/${region}/${link}`} />
                </SwiperSlide>
              ))}
            </Categories>
          </Swiper>
        </ProductListCarousel>
        {!showMore && (
          <ShowMore onClick={() => setShowMore(true)} data-testid="show-more">
            Show more popular categories
          </ShowMore>
        )}
      </CategoriesWrapper>
    </>
  )
}

export default PopularCategories
